import request from '../utils/request';
import {stringify} from 'qs'

// 一键新机价格

export async function getPrices (params: object) {
    return request(`/api/bill/device/vas/prices?${stringify(params)}`, {
        method: 'GET',
        requestType: 'form',
        data: params,
    })
}

// 获取分组列表

export async function getGroupList (params: object) {
  return request(`/api/user/group/list?${stringify(params)}`, {
    method: 'GET',
    requestType: 'form',
    data: params,
  })
}

//获取组内购买增值服务的设备列表

export async function getDeviceList (params: object) {
  return request(`/api/user/group/device/vas/device/list?${stringify(params)}`, {
    method: 'GET',
    requestType: 'form',
    data: params,
  })
}

//生成订单

export async function deviceBuyIp (params: object) {
    return request(`/api/bill/device/vas/buy/ip`, {
        method: 'POST',
        requestType: 'form',
        data: params,
    })
}
//一键新机

export async function deviceBuyVas (params: object) {
  return request(`/api/bill/device/vas/buy`, {
    method: 'POST',
    requestType: 'form',
    data: params,
  })
}

//IP服务等级价格点
export async function getGradePrice (params: object) {
    return request(`/api/bill/device/vas/grade/prices?${stringify(params)}`, {
        method: 'GET',
        requestType: 'form',
        data: params,
    })
}
// IP服务等级接口
export async function getGrade (params: object) {
  return request(`/api/bill/device/vas/grade?${stringify(params)}`, {
    method: 'GET',
    requestType: 'form',
    data: params,
  })
}
// web 端后台配置和校验使用的数据
export async function getDeviceConfig(params: object) {
  return request(`/api/bill/device/config?${stringify(params)}`, {
    method: 'GET',
    requestType: 'form',
    data: params,
  })
}


